module.exports = __webpack_public_path__ + "img/360-degrees.57e2cdba.png";